(() => {
  if (window.BeautyFashionCartUI) return;

  const setCount = (count, root = document) => {
    const value = Math.max(0, Number.parseInt(count, 10) || 0);
    root.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = String(value);
      badge.hidden = value === 0;
      badge.setAttribute('aria-label', `${value} ${value === 1 ? 'item' : 'items'} in cart`);
    });
  };

  const isOtherSurfaceOpen = () => Boolean(document.querySelector('.bf-drawer.is-open:not(#CartDrawer),.search-overlay.is-open,dialog[open]'));
  const isDrawerOpen = () => document.getElementById('CartDrawer')?.getAttribute('aria-hidden') === 'false';

  const setDrawerOpen = (open, { restoreFocus = true } = {}) => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('is-locked', open || isOtherSurfaceOpen());
    if (open) document.dispatchEvent(new CustomEvent('beautyfashion:cart-engaged'));
    if (!open && restoreFocus) document.querySelector('[data-drawer-open="CartDrawer"]')?.focus();
  };

  window.BeautyFashionCartUI = { setCount, setDrawerOpen, isDrawerOpen };
})();
